package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.repository.ClientRepository

class DeleteClientUseCase(
    private val repository: ClientRepository
) {
    suspend operator fun invoke(clientId: String): Result<Unit> {
        return repository.deleteClient(clientId)
    }
}
